export const classes = {
  wrapper: 'flex w-full justify-between items-start gap-2',
  authorWrapper: 'flex items-baseline gap-[7px] flex-wrap min-w-0',
  createdBy: 'text-[13px] font-bold text-taupe-3 dark:text-mauve-1',
  createdAt: 'text-[11.5px] font-medium text-taupe-1 dark:text-mauve-3',
};
